import { Component } from '@angular/core';
import { AGB_LINK, IMPRESSUM } from '@constants/general.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  protected agbLink = AGB_LINK;
  protected impressumLink = IMPRESSUM;
}
